import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useAlerts } from "../store/alerts/hooks";
import { ArrowBack } from "@mui/icons-material";

const maxWidth = "20rem";
const width = "30rem";

export const ContentTitleBar = ({
  boxRef,
  caseFileNumber,
  description,
  fieldOffice,
  isTrashView,
  menu,
  name,
  label,
  onBack,
  removeTrashFilter,
}) => {
  const theme = useTheme();
  const { closeStipaAlert, showStipaAlert } = useAlerts();
  const handleCancel = () => removeTrashFilter();

  return (
    <Box
      backgroundColor={
        isTrashView ? theme.palette.secondary.main : theme.palette.primary.main
      }
      display="flex"
      alignItems="center"
      height={64}
      justifyContent="space-between"
      flexShrink={0}
      pl={onBack ? 0 : 2}
      pr={2}
      ref={boxRef}
    >
      <Box display="flex" alignItems="center" ml={0} pl={0}>
        {onBack && (
          <Tooltip title="Back">
            <IconButton
              size="large"
              sx={{ mr: 0.5 }}
              onClick={() =>
                onBack && !isTrashView
                  ? (onBack(), showStipaAlert && closeStipaAlert())
                  : handleCancel()
              }
            >
              <ArrowBack sx={{ color: theme.palette.common.white }} />
            </IconButton>
          </Tooltip>
        )}
        <Stack alignItems="start" justifyContent="center">
          {name && (
            <Typography
              color={theme.palette.primary.contrastText}
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: width,
              }}
              variant="caption"
            >
              {name}
            </Typography>
          )}
          {label && (
            <Typography
              color={theme.palette.primary.contrastText}
              lineHeight={1.1}
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: width,
              }}
              variant="subtitle1"
            >
              {label}
            </Typography>
          )}
        </Stack>
      </Box>
      <Box display="flex" gap={2} alignItems="center" justifyContent="center">
        <Stack alignItems="flex-end">
          <Box display="flex">
            {caseFileNumber && (
              <Typography
                noWrap
                variant="caption"
                color={theme.palette.primary.contrastText}
                maxWidth={maxWidth}
              >
                {caseFileNumber}
              </Typography>
            )}
            {caseFileNumber && fieldOffice && (
              <Typography
                noWrap
                variant="caption"
                color={theme.palette.primary.contrastText}
                maxWidth={maxWidth}
                mx={0.5}
              >
                |
              </Typography>
            )}
            {fieldOffice && (
              <Typography
                noWrap
                variant="caption"
                color={theme.palette.primary.contrastText}
                maxWidth={maxWidth}
              >
                {fieldOffice}
              </Typography>
            )}
          </Box>
          {description && (
            <Typography
              noWrap
              variant="caption"
              color={theme.palette.primary.contrastText}
              maxWidth={maxWidth}
            >
              {description}
            </Typography>
          )}
        </Stack>
        {menu && <Box>{menu}</Box>}
      </Box>
    </Box>
  );
};
